import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const complianceRoutes: Route = {
    path: 'compliance',
    data: { title: 'compliance' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'data-request' },
        {
            path: 'data-request',
            loadComponent: () => import('./data-request/data-request.component').then((m) => m.DataRequestComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'data-request' },
        },
        {
            path: 'data-request-type',
            loadComponent: () =>
                import('./data-request-type/data-request-type.component').then((m) => m.DataRequestTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Data request type' },
        },
    ],
};
